import { render, staticRenderFns } from "./dictioneryTemplate.vue?vue&type=template&id=0ae08a5f&scoped=true&"
import script from "./dictioneryTemplate.vue?vue&type=script&lang=js&"
export * from "./dictioneryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dictioneryTemplate.vue?vue&type=style&index=0&id=0ae08a5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae08a5f",
  null
  
)

export default component.exports